import { Tabs, TabsList, TabsTrigger } from "@repo/ui/components/tabs";
import { createFileRoute, Outlet, useLocation, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/fan-pics")({
  component: RouteComponent,
});

const navItems = [
  {
    label: "Uploads",
    to: "/fan-pics/uploads",
  },
  {
    label: "QR Codes",
    to: "/fan-pics/qr-codes",
  },
] as const;

function RouteComponent() {
  const location = useLocation();
  const navigate = useNavigate();
  const activeTab = location.pathname.endsWith("/qr-codes")
    ? "/fan-pics/qr-codes"
    : "/fan-pics/uploads";

  return (
    <div className="fan-pics-theme flex h-full min-h-0 flex-col gap-4 p-4">
      <div className="space-y-1">
        <h1 className="text-2xl font-semibold tracking-tight">FanPics</h1>
        <p className="text-sm text-muted-foreground">
          Review public uploads and manage QR codes for players.
        </p>
      </div>

      <Tabs
        value={activeTab}
        onValueChange={(value) => {
          void navigate({
            to: value === "/fan-pics/qr-codes" ? "/fan-pics/qr-codes" : "/fan-pics/uploads",
          });
        }}
      >
        <TabsList>
          {navItems.map((item) => (
            <TabsTrigger key={item.to} value={item.to}>
              {item.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>

      <Outlet />
    </div>
  );
}
